export const SectionContact = /* GraphQL */ `
  fragment SectionContact on SectionContactRecord {
    id
    title
    links {
      ...CallToAction
    }
  }
`

export const SectionHero = /* GraphQL */ `
  fragment SectionHero on SectionHeroRecord {
    id
    video {
      ...Video
    }
  }
`

export const SectionStructuredText = /* GraphQL */ `
  fragment SectionStructuredText on SectionStructuredTextRecord {
    title
    subtitle
    structuredText {
      blocks {
        ... on RecordInterface {
          id
          _modelApiKey
          __typename
        }
        ...CallToAction
        ...Iframe
        ...Media
        ...Table
        ...VideoExternal
      }
      links {
        ... on RecordInterface {
          id
          __typename
          _modelApiKey
        }
        ... on PageRecord {
          title
          slug
        }
      }
      value
    }
  }
`

export const SectionLogos = /* GraphQL */ `
  fragment SectionLogos on SectionLogosListRecord {
    id
    records {
      name
      media {
        alt
        url
        width
        height
        responsiveImage(imgixParams: { auto: compress, crop: focalpoint, fit: crop, h: 50 }) {
          ...ResponsiveImage
        }
      }
      url
    }
  }
`

export const SectionLead = /* GraphQL */ `
  fragment SectionLead on SectionLeadRecord {
    id
    text
    align
    backgroundVariant
    links {
      color
      link {
        ...CallToAction
      }
    }
  }
`

export const SectionStats = /* GraphQL */ `
  fragment SectionStats on SectionStatsListRecord {
    id
    stats {
      label
      value
    }
  }
`

export const SectionHeroAbout = /* GraphQL */ `
  fragment SectionHeroAbout on SectionHeroAboutRecord {
    id
    title
  }
`

export const SectionServices = /* GraphQL */ `
  fragment SectionServices on SectionServiceListRecord {
    id
    title
    html
    services {
      title
      html
    }
  }
`

export const SectionBigLead = /* GraphQL */ `
  fragment SectionBigLead on SectionBigLeadRecord {
    id
    content
    background
  }
`

export const SectionProjects = /* GraphQL */ `
  fragment SectionProjects on SectionProjectListRecord {
    _modelApiKey
    id
    recordsPerPage
    loadMoreLabel
    title
  }
`

export const SectionLocations = /* GraphQL */ `
  fragment SectionLocations on SectionLocationListRecord {
    _modelApiKey
    id
    categories {
      __typename
      _modelApiKey
      name
      id
      slug
    }
    countries {
      __typename
      _modelApiKey
      name
      id
      slug
    }
    recordsPerPage
    loadMoreLabel
    title
  }
`

export const SectionFeaturedProjects = /* GraphQL */ `
  fragment SectionFeaturedProjects on SectionFeaturedProjectsListRecord {
    _modelApiKey
    id
    title
    overrideProjects {
      _modelApiKey
      id
      title
      slug
      video {
        ...Video
      }
    }
    location {
      id
      title
    }
    recordsCount
  }
`

export const SectionLocationMap = /* GraphQL */ `
  fragment SectionLocationMap on SectionLocationMapRecord {
    title
    media {
      alt
      url
      width
      height
      responsiveImage(imgixParams: { auto: compress, crop: focalpoint, fit: crop, w: 1440 }) {
        ...ResponsiveImage
      }
    }
    table {
      ...Table
    }
  }
`

export const SectionFeaturedLocations = /* GraphQL */ `
  fragment SectionFeaturedLocations on SectionFeaturedLocationListRecord {
    _modelApiKey
    id
    title
    imageGallery {
      alt
      url
      width
      height
      title
      responsiveImage(imgixParams: { auto: compress, crop: focalpoint, fit: crop, w: 1440 }) {
        ...ResponsiveImage
      }
    }
    location {
      id
      _modelApiKey
      title
      slug
    }
    category {
      _modelApiKey
      __typename
      id
      name
      slug
    }
    country {
      _modelApiKey
      __typename
      id
      name
      locale
      slug
    }
  }
`

export const SectionLocationInfo = /* GraphQL */ `
  fragment SectionLocationInfo on SectionLocationInfoRecord {
    _modelApiKey
    id
    title
    generalInfo
    holidays
  }
`

export const SectionAboutImage = /* GraphQL */ `
  fragment SectionAboutImage on SectionAboutImageRecord {
    id
    gallery {
      alt
      url
      width
      height
      title
      responsiveImage(imgixParams: { auto: compress, crop: focalpoint, fit: crop, w: 1440 }) {
        ...ResponsiveImage
      }
    }
    variant
  }
`

export const SectionThumbnails = /* GraphQL */ `
  fragment SectionThumbnails on SectionThumbnailListRecord {
    id
    title
    variant
    gallery {
      alt
      url
      width
      height
      title
      responsiveImage(imgixParams: { auto: compress, crop: focalpoint, fit: crop, w: 1440 }) {
        ...ResponsiveImage
      }
    }
    link {
      ...CallToAction
    }
  }
`

export const SectionOverview = /* GraphQL */ `
  fragment SectionOverview on SectionOverviewRecord {
    id
    titleProductionServices
    productionServices {
      title
      html
    }
    link {
      ...CallToAction
    }
    titleServices
    services {
      title
      html
    }
  }
`

export const SectionContentList = /* GraphQL */ `
  fragment SectionContentList on SectionContentListRecord {
    id
    background
    variant
    services {
      title
      html
    }
  }
`

export const SectionTitle = /* GraphQL */ `
  fragment SectionTitle on SectionTitleRecord {
    id
    background
    title
  }
`

export const SectionPush = /* GraphQL */ `
  fragment SectionPush on SectionPushRecord {
    id
    title
    html
    links {
      ...CallToAction
    }
  }
`

export const SectionAnchor = /* GraphQL */ `
  fragment SectionAnchor on SectionAnchorRecord {
    id
    anchorId
  }
`

export const SectionArticles = /* GraphQL */ `
  fragment SectionArticles on SectionArticleListRecord {
    _modelApiKey
    id
    categories {
      __typename
      _modelApiKey
      name
      id
      slug
    }
    recordsPerPage
    loadMoreLabel
    title
  }
`
